import React from 'react';
import { SpinnerContainer, Spinner, SpinnerDot, SpinnerText } from './LoadingSpinner.styles';

const LoadingSpinner = ({ size = 'medium', text = '', variant = 'spinner' }) => {
  if (variant === 'dots') {
    return (
      <SpinnerContainer>
        <div style={{ display: 'flex', gap: '8px' }}>
          <SpinnerDot delay="0s" />
          <SpinnerDot delay="0.2s" />
          <SpinnerDot delay="0.4s" />
        </div>
        {text && <SpinnerText>{text}</SpinnerText>}
      </SpinnerContainer>
    );
  }

  return (
    <SpinnerContainer>
      <Spinner size={size} />
      {text && <SpinnerText>{text}</SpinnerText>}
    </SpinnerContainer>
  );
};

export default LoadingSpinner;

